"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRailwayModule = createRailwayModule;
exports.state = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.replace");

var _moment = _interopRequireDefault(require("moment"));

var _getters = require("./getters");

var _actions = require("./actions");

var _mutations = require("./mutations");

var _constants = require("./constants");

var state = {
  // projectCodes: [],
  // drivers: [],
  // selectedDriver: null,
  // trucks: [],
  // bufferTrucks: [],
  // selectedTruck: null,
  pagination: _constants.DEFAULT_PAGINATION,
  defaultPagination: _constants.DEFAULT_PAGINATION,
  defaultTableSize: _constants.DEFAULT_PAGE_SIZE,
  defaultOrderColumns: _constants.DEFAULT_ORDER_COLUMNS,
  selectedColumns: _constants.DEFAULT_ORDER_COLUMNS,
  orderColumns: [].toString().replace(/,/g, '|'),
  orderColumnTemplates: [],
  unassignedOrders: [],
  excludedOrders: [],
  includedOrders: [],
  selectedOrders: [],
  orderFilters: [],
  incidents: [],
  dateRangeOption: 'all',
  startDate: (0, _moment.default)(new Date()).subtract(1, 'days').format('YYYY-MM-DD 00:00:00'),
  endDate: (0, _moment.default)(new Date()).add(3, 'days').format('YYYY-MM-DD 23:59:59'),
  tableLoading: true,
  plan: {},
  anyChanges: false,
  isPlanExists: false,
  defaultLocationType: 'pickup',
  locationType: null,
  truckFilters: [],
  truckLoading: true,
  searchType: 'fuzzySearch',
  locations: [],
  failedOrders: [],
  savedOrderIds: [],
  isManualAssignLoading: false,
  isAssignedDriverChanges: false,
  isUnassignedDriverChanges: false
};
exports.state = state;
var namespaced = true;
var MilkRunModule = {
  namespaced: namespaced,
  state: state,
  getters: _getters.getters,
  actions: _actions.actions,
  mutations: _mutations.mutations
};

function createRailwayModule() {
  return MilkRunModule;
}